import React, { useState, useEffect } from "react";
import { Button } from "./components/Button";
import bg from "../../assets/images/homepage/welcome_bg_purple.svg";
// import { useLoading } from "../../contexts/LoadingContext";
import usePartnerAwareNavigate from "src/hooks/usePartnerAwareNavigate";
// import interviewIcon from "../../assets/images/homepage/interviewIcon.jpg";
// import reportIcon from "../../assets/images/homepage/myreportsIcon.pic.jpg";

interface WelcomeSectionProps {
    companyName?: string;
    name: string;
    interviewCount: number;
    reportCount?: number;
    boughtInterview?: boolean;
    reportInterview?: boolean;
    freeInterviewCount?: number;
    boughtInterviewCount?: number;
    freeReportCount?: number;
    boughtReportCount?: number;
}

const companyIntroMap: { [key: string]: string } = {
    "career-accelerator": `Powered by AI trained by MBB interviewers, we deliver realistic mock interviews that mirror top consulting firm standards. Your consulting career starts here! `,
    seeu: "",
    "ucla-bsn":
        "Bruin Strategy Network (formerly CYC at UCLA) offers managment and healthcare consulting for companies ranging from start-ups to Fortune 500!",
};

// Add SVG icons with primary color
const InterviewIcon = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z"
            fill="var(--color-primary)"
        />
        <path
            d="M12 15L13.57 11.57L17 10L13.57 8.43L12 5L10.43 8.43L7 10L10.43 11.57L12 15Z"
            fill="var(--color-primary)"
        />
    </svg>
);

const ReportIcon = () => (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM18 20H6V4H13V9H18V20Z"
            fill="var(--color-primary)"
        />
        <path
            d="M9 13H15V15H9V13ZM9 16H15V18H9V16ZM9 10H11V12H9V10Z"
            fill="var(--color-primary)"
        />
    </svg>
);

export const WelcomeSection: React.FC<WelcomeSectionProps> = ({
    companyName,
    name,
    interviewCount,
    reportCount = 0,
    boughtInterview = false,
    reportInterview = false,
    freeInterviewCount,
    boughtInterviewCount,
    freeReportCount,
    boughtReportCount,
}) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const displayName = name || "wekruiter";
    const navigate = usePartnerAwareNavigate();
    const companyIntro = companyIntroMap[companyName || ""] || "";

    // Use detailed counts if provided, otherwise use totals
    const showDetailedCounts =
        freeInterviewCount !== undefined && boughtInterviewCount !== undefined;

    useEffect(() => {
        setIsLoaded(true);
    }, []);

    const handleStartMockInterview = () => {
        navigate("/interviews");
    };

    const handleStartWeeklyContest = async () => {
        navigate("/weekly-contest");
    };

    return (
        <div className="home-welcome relative h-96 overflow-hidden rounded">
            {/* Background Image without zoom effect */}
            <div
                className="absolute inset-0 bg-cover bg-center"
                style={{
                    backgroundImage: `url(${bg})`,
                }}
            />

            {/* Light Gradient Overlay - static version */}
            <div
                className="absolute inset-0"
                style={{
                    background:
                        "linear-gradient(145deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.7) 100%)",
                    opacity: 0.05,
                }}
            />

            {/* Content container without animations */}
            <div className="relative h-full">
                <div className="absolute bottom-12 left-8 max-w-2xl">
                    <h1 className="text-4xl font-bold mb-4 text-text-primary">
                        Hello, {displayName}. Let's ace that interview!
                    </h1>

                    <p className="mb-4 text-text-secondary">
                        {companyIntro && companyIntro.length > 0
                            ? companyIntro
                            : `WeKruit is your ultimate partner for consulting
                        interview success. Powered by AI trained by MBB
                        interviewers, we deliver realistic mock interviews that
                        mirror top consulting firm standards. Your consulting
                        career starts here!`}
                    </p>

                    {/* User stats section */}
                    <div className="flex items-center gap-6 mb-6">
                        <div className="flex items-center gap-2">
                            <InterviewIcon />
                            {showDetailedCounts ? (
                                <div className="flex flex-col">
                                    <span className="text-text-primary font-medium">
                                        {interviewCount}{" "}
                                        {interviewCount === 1
                                            ? "Interview"
                                            : "Interviews"}{" "}
                                        Available
                                    </span>
                                    <span className="text-xs text-text-tertiary">
                                        {/* {freeInterviewCount} free + {boughtInterviewCount} premium */}
                                    </span>
                                </div>
                            ) : (
                                <span className="text-text-primary font-medium">
                                    {interviewCount}{" "}
                                    {interviewCount === 1
                                        ? "Interview"
                                        : "Interviews"}{" "}
                                    Available
                                </span>
                            )}
                            {/* {boughtInterview && (
                <span className="bg-primary/10 text-primary text-xs font-semibold px-2 py-0.5 rounded-full ml-2">
                  Premium
                </span>
              )} */}
                        </div>

                        {/* <div className="flex items-center gap-2">
                            <ReportIcon />
                            {showDetailedCounts &&
                            freeReportCount !== undefined &&
                            boughtReportCount !== undefined ? (
                                <div className="flex flex-col">
                                    <span className="text-text-primary font-medium">
                                        {reportCount}{" "}
                                        {reportCount === 1
                                            ? "Report"
                                            : "Reports"}{" "}
                                        Available
                                    </span>
                                    <span className="text-xs text-text-tertiary">
                                        {freeReportCount} free +{" "}
                                        {boughtReportCount} premium
                                    </span>
                                </div>
                            ) : (
                                <span className="text-text-primary font-medium">
                                    {reportCount}{" "}
                                    {reportCount === 1 ? "Report" : "Reports"}{" "}
                                    Available
                                </span>
                            )}
                            {reportInterview && (
                <span className="bg-success/10 text-success text-xs font-semibold px-2 py-0.5 rounded-full ml-2">
                  Premium
                </span>
              )}
                        </div> */}
                    </div>

                    {companyIntro && companyIntro.length == 0 && (
                        <p className="mb-8 text-text-secondary">
                            Follow our LinkedIn page to get more free tokens!
                        </p>
                    )}
                    {companyIntro && companyIntro.length > 0 && (
                        <p className="mb-8 text-text-secondary">
                            Technology supported by WeKruit
                        </p>
                    )}

                    <div className="flex gap-4">
                        <Button
                            onClick={handleStartMockInterview}
                            className="text-white bg-primary hover:bg-primary/90 px-6 py-2 rounded">
                            Start An Interview
                        </Button>

                        <Button
                            onClick={handleStartWeeklyContest}
                            className=" bg-white border border-gray-300 px-6 py-2 rounded">
                            Weekly Contest
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WelcomeSection;
